import { Icon } from "@iconify/react";
import shareFill from "@iconify/icons-eva/share-fill";
import twitterFill from "@iconify/icons-eva/twitter-fill";
import linkedinFill from "@iconify/icons-eva/linkedin-fill";
import facebookFill from "@iconify/icons-eva/facebook-fill";
import instagramFilled from "@iconify/icons-ant-design/instagram-filled";
// material
import { alpha, useTheme, styled } from "@mui/material/styles";
import {
  Box,
  Avatar,
  SpeedDial,
  Typography,
  useMediaQuery,
  SpeedDialAction,
} from "@mui/material";
// utils
import { fDate } from "../../utils/formatTime";
// @types
import { Post } from "../../types/blog";

// ----------------------------------------------------------------------

const SOCIALS = [
  {
    name: "Facebook",
    icon: <Icon icon={facebookFill} width={20} height={20} color="#1877F2" />,
  },
  {
    name: "Instagram",
    icon: (
      <Icon icon={instagramFilled} width={20} height={20} color="#D7336D" />
    ),
  },
  {
    name: "Linkedin",
    icon: <Icon icon={linkedinFill} width={20} height={20} color="#006097" />,
  },
  {
    name: "Twitter",
    icon: <Icon icon={twitterFill} width={20} height={20} color="#1C9CEA" />,
  },
];

const RootStyle = styled("div")(({ theme }) => ({
  height: 480,
  position: "relative",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  [theme.breakpoints.up("md")]: {
    height: "auto",
    paddingTop: "calc(100% * 9 / 16)",
  },
  "&:before": {
    top: 0,
    zIndex: 9,
    content: "''",
    width: "100%",
    height: "100%",
    position: "absolute",
    // backgroundColor: alpha(theme.palette.grey[900], 0.72),
  },
}));

const TitleStyle = styled("h1")(({ theme }) => ({
  top: 0,
  zIndex: 10,
  width: "100%",
  position: "absolute",
  padding: theme.spacing(3),
  // color: theme.palette.common.white,
  // [theme.breakpoints.up("lg")]: {
  //   padding: theme.spacing(10),
  // },
}));

const FooterStyle = styled("div")(({ theme }) => ({
  bottom: 0,
  zIndex: 10,
  width: "100%",
  display: "flex",
  position: "absolute",
  alignItems: "flex-end",
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(3),
  justifyContent: "space-between",
  [theme.breakpoints.up("sm")]: {
    alignItems: "center",
    paddingRight: theme.spacing(3),
  },
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(10),
  },
}));

const CoverImgStyle = styled("img")(({ theme }) => ({
  top: 0,
  zIndex: 8,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  position: "absolute",
}));

// ----------------------------------------------------------------------

type BlogPostHeroProps = {
  post: Post;
};

export default function BlogPostHero({ post }: BlogPostHeroProps) {
  const { cover, title, author, createdAt } = post;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <RootStyle>
      <CoverImgStyle alt="post cover" src={cover} />

      <TitleStyle sx={{ typography: "h4" }}>{title}</TitleStyle>

      <FooterStyle>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Avatar
            alt={author.name}
            // src={author.avatarUrl}
            src="https://firebasestorage.googleapis.com/v0/b/refrigeration-9e407.firebasestorage.app/o/avatar%2Favatar.webp?alt=media&token=ee0c08d9-8d64-4937-9e2d-6203c00c1c58"
            sx={{ width: 48, height: 48 }}
          />
          <Box sx={{ ml: 2 }}>
            <Typography variant="subtitle1" sx={{}}>
              {/* {author.name} */}Hồ Giáp
            </Typography>
            <Typography variant="body2" sx={{ color: "grey.500" }}>
              {fDate(createdAt)}
            </Typography>
          </Box>
        </Box>

        <SpeedDial
          direction={isMobile ? "up" : "left"}
          ariaLabel="Share post"
          icon={<Icon icon={shareFill} />}
          sx={{ "& .MuiSpeedDial-fab": { width: 48, height: 48 } }}
        >
          {SOCIALS.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              tooltipPlacement="top"
              FabProps={{ color: "default" }}
            />
          ))}
        </SpeedDial>
      </FooterStyle>
    </RootStyle>
  );
}
